import Minze, { EventListeners, MinzeElement } from 'minze'
import Swiper, { Navigation, Pagination } from 'swiper'
import styles from 'swiper/swiper-bundle.min.css?inline'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'

Swiper.use([Navigation, Pagination])

export interface LvcEventSeriesDates {
  dates: string
}

interface EventDate {
  day: string
  month: string
  year: string
  date: string
}

export class LvcEventSeriesDates extends MinzeElement {
  attrs = ['dates']
  swiper: Swiper | null = null
  decodeObject = (json: string) => JSON.parse(decodeURIComponent(json))

  chooseDate = (event: Event) => {
    const dateCard = (event.target as Element)?.closest('.date-card') as Element | null
    if (!dateCard) return
    const classList = dateCard.classList
    const classWithIndex = Array.from(classList).find((cl: string) =>
      /^date-card-item-(\d+)$/.test(cl)
    )
    if (!classWithIndex) return
    const index = parseInt(classWithIndex.match(/^date-card-item-(\d+)$/)?.[1] ?? '', 10)
    const dates = this.decodeObject(this.dates)
    Minze.cast('lvc:event-series-date-change', {
      selectedDate: dates[index].date,
      selectedDateInfo: dates[index],
    })
  }

  renderItem = (item: EventDate, index: number) => {
    return `
    <div class="swiper-slide">
      <div class="date-card date-card-item-${index}">
        <lvc-event-date-card data-is-active="${index === 0}" data-date-info="${JSON.stringify(item).split('"').join("'")}">
          <span slot="date">${item.day}</span>
          <span slot="month">${item.month}</span>
          <span slot="year">${item.year}</span>
        </lvc-event-date-card>
      </div>
    </div>
  `
  }

  onReady() {
    this.dates = this.decodeObject(this.dates)
    const swiperContainer = this.shadowRoot?.querySelector('.swiper-container') as HTMLElement
    const nextButton = this.shadowRoot?.querySelector('.swiper-button-next') as HTMLElement
    const prevButton = this.shadowRoot?.querySelector('.swiper-button-prev') as HTMLElement
    if (swiperContainer && nextButton && prevButton) {
      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 'auto',
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
      })
    }
    this.rerender()
  }
  onRender = () => {
    this.swiper?.navigation.update()
  }

  html = () => `
    <div class="swiper-component">
      <div id="swiper" class="swiper-container">
        <div class="swiper-wrapper">
          ${this.decodeObject(this.dates)
            .map((date: EventDate, index: number) => this.renderItem(date, index))
            .join('')}
        </div>
      </div>
      <div class="swiper-button-prev" aria-label="previous slide">
        <button class="swiper-button">
          <lvc-slider-arrow-left-icon></lvc-slider-arrow-left-icon>
        </button>
      </div>
      <div class="swiper-button-next" aria-label="next slide">
        <button class="swiper-button">
          <lvc-slider-arrow-right-icon></lvc-slider-arrow-right-icon>
        </button>
      </div>
    </div>
  `

  css = () => `
    :host {
      width: 100%
    }
    ${styles}
    .swiper-component {
      position: relative;
    }
    .swiper-container {
      -webkit-user-select: none; /* Safari */
      -ms-user-select: none; /* IE 10 and IE 11 */
      user-select: none; /* Standard syntax */
      position: relative;
      padding: ${this.swiper?.isLocked ? '0' : '0 59px;'};
      overflow: hidden;
      mask-image: ${this.swiper?.isLocked ? 'none' : 'linear-gradient(to right, transparent 0%, black 65px calc(100% - 65px), transparent 100%)'};
    }
    .swiper-slide {
      width: auto;
    }
    .swiper-button {
      width: 47px;
      height: 47px;
      background: white;
      border-radius: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      cursor: pointer;
      transition: box-shadow 200ms ease;
    }
    .swiper-button {
      box-shadow: 0 6px 8px 2px rgba(30, 0, 125, 0.05);
      transition: box-shadow ease 0.3s;
    }
    .swiper-button:hover {
      box-shadow: 0 6px 8px 2px rgba(30, 0, 125, 0.18);
    }
    .swiper-button-prev, .swiper-button-next {
      position: absolute;
      top: var(--swiper-navigation-top-offset);
      bottom: 0;
      z-index: 100;
      width: auto;
      height: 100%;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
    .swiper-slide-prev {
    }
    .swiper-container:has(.swiper-button-lock) {
      padding: 0;
    }
    .swiper-button-next:after, .swiper-button-prev:after {
      content: "";
      display: none;
    }
    .swiper-button-prev > div, .swiper-button-next > div {
      width: 47px;
      height: 47px;
      background: white;
      border-radius: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `

  eventListeners: EventListeners = [['.date-card', 'click', this.chooseDate]]
}
